import { h, Fragment, ComponentChildren } from "preact"; /** @jsx h */

import { type ICourse, type IWiki, type IPassage } from "@pyqml/model";


import { ROUTES, timestampStringInEnglish } from '@pyqml/shared';

import { useEnvironment } from "../app/Environment";
import { useCacheableQueryProvider } from "../app/CacheableQueryProvider";
import { Layout } from './Layout';
import { List } from './List';
import { Subheader } from './Subheader';
import { Content } from "./Content";
import { ContentItem } from "./ContentItem";

import { SubscribeSection } from '../glue/SubscribeSection';


import { BlogCover } from './BlogCover';

export type IWikiCourseCombiProps = {
    //content: string;
    //featuredItems: Array<IPyQMLItem>,
    wikiData: IWiki;
    courseData: ICourse;
};

/**
 * This is the main component for the Algorithm Course page.
 * It does NOT support paywalled content.
 * 
 * Show mainly the wiki content, and the course content in a list.
 */
export const WikiCourseCombi = (props: IWikiCourseCombiProps) => {

    const { baseUrl, imageUrl, subdomain } = useEnvironment();
    
    const { wikiData, courseData } = props;


    return <Layout.FixedColumn>
        <Fragment as="Section" weight="teaser">
            <BlogCover  title={wikiData.title} subtitle={wikiData.subtitle} />
        </Fragment>

        
        <Layout.Section weight="full" >
            {
                wikiData.abstractImage && <div className="container pt-4 pb-4">
                    <div className="row justify-content-center">
                        <img src={ `/${subdomain}/${wikiData.abstractImage}`}></img>    
                    </div>
                </div>
            
            }
        </Layout.Section>

        <Layout.Section weight="full" >
            <Content weight="full">
                
                <ContentItem contentId={"contentElement"} text={wikiData?.content ?? ""} paywalled={""} />
                
            
            </Content>
        </Layout.Section>
        
        {
            wikiData.passages?.length > 0 && <Layout.Fixed weight="full">
                <Subheader title={`More about ${wikiData.title}`}/>
                <List.Standard>
                {
                        wikiData?.passages?.map((passage: IPassage) => (
                            <List.Item
                                title={ passage.title }
                                abstract={ passage.abstract }
                                image={ passage.abstractImage ? `${imageUrl}/${passage.abstractImage}` : undefined}
                                linkTo={ `${baseUrl}${ROUTES.BLOG_WIKI}/${wikiData.slug}/${passage.slug}` }
                                
                            />
                        ))
                    }
                    
                </List.Standard>
            </Layout.Fixed>
        }
        
        <Layout.Section weight="full">
            <Subheader title="In this Module" />
            <List.Standard>
            {
                    courseData.pageAbstracts?.map((page: IPage) => (
                        <List.Item
                            title={ page.title }
                            abstract={ page.abstract }
                            image={ page.abstractImage ? `${imageUrl}/${page.abstractImage}` : undefined}
                            linkTo={ `${baseUrl}/${page.slug}` }
                            authorLinkTo="./frank"
                            authorName="Dr. Frank Zickert"
                            publishedAt={ timestampStringInEnglish( page.orig_revision ? page.orig_revision : page.revision ) }
                            readingTime={ page.readingTime ?? undefined }
                        />
                    ))
                }
                
            </List.Standard>
            
        
        </Layout.Section>
        
        <SubscribeSection as="Section"/>
        
        


    </Layout.FixedColumn>
}
